module.exports = __webpack_public_path__ + "static/media/isoCeritifiedG.61943073.PNG";